module.exports = __webpack_public_path__ + "static/media/arrow-long-curved2.a78f3993.svg";